const CitesMetadaten = () => {
    return {
        touched: {
            value:false,
        },
        wurdeVersandt: {
            value:null,
        },
    }
}
export default CitesMetadaten;